import { SVGProps, Ref, forwardRef } from 'react';

export const ScooterFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M20.386 16.012 16.717 0H12v1.8h3.283l3.295 14.38c-1.553.436-2.288 1.61-2.506 2.92H7.928C7.652 17.441 6.547 16 4 16c-3 0-4 2-4 4s1 4 4 4c2.547 0 3.652-1.441 3.928-3.1h8.144C16.348 22.559 17.453 24 20 24c3 0 4-2 4-4 0-1.912-.913-3.823-3.614-3.988"
                    fill="currentColor"
                />
                <path d="M2 6.1h7v1.8H2z" fill="currentColor" />
                <path d="M12 11.1H5v1.8h7z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
ScooterFilledSize24Glyph.displayName = 'ScooterFilledSize24Glyph';
